module.exports = __webpack_public_path__ + "static/userexperience1-cfd5a556fa22656cef25e6803bdcf4ef.png";